import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, catchError, switchMap, filter, take } from 'rxjs/operators';

import { ProfileGateway } from '../../services/gateway/profile.gateway';
import * as ProfileActions from './profile.actions';
import * as AuthActions from '../auth/auth.actions';
import { selectSubscriptionLoaded } from '../subscription/subscription.selectors';

@Injectable()
export class ProfileEffects {
  constructor(private actions$: Actions, private profileGateway: ProfileGateway, private store: Store) {}

  // Load profile effect
  loadProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProfileActions.loadProfile),
      switchMap(() =>
        this.profileGateway.getProfileInfo().pipe(
          map((profile) => ProfileActions.loadProfileSuccess({ profile })),
          catchError((error) => of(ProfileActions.loadProfileFailure({ error: error.message || 'Failed to load profile' })))
        )
      )
    )
  );

  // Clear profile on logout
  clearProfileOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      map(() => ProfileActions.clearProfile())
    )
  );

  // Auto-load profile on login success, but wait for subscription to be loaded first
  loadProfileOnLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      switchMap(() =>
        this.store.select(selectSubscriptionLoaded).pipe(
          filter((loaded) => loaded), // Wait until subscription is loaded
          take(1), // Take the first emission where subscription is loaded
          map(() => ProfileActions.loadProfile())
        )
      )
    )
  );
}
